import { useEffect } from "react";

const SITE_NAME = "Ekselowe.pl";

function upsertMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

/**
 * Ustawia tytuł strony i meta description/Open Graph na podstawie
 * przekazanych danych. Dzięki temu każda podstrona (w tym każdy wpis
 * w Aktualnościach) ma własny, unikalny tytuł i opis widoczny w
 * wynikach wyszukiwania Google oraz w podglądach na social media.
 */
function upsertCanonical(url) {
  if (!url) return;
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", url);
}

export default function useDocumentMeta({ title, description, image, url, keywords }) {
  useEffect(() => {
    const fullTitle = title ? `${title} — ${SITE_NAME}` : SITE_NAME;
    document.title = fullTitle;

    if (description) {
      upsertMeta("name", "description", description);
      upsertMeta("property", "og:description", description);
    }
    if (keywords) {
      upsertMeta("name", "keywords", keywords);
    }
    upsertMeta("property", "og:title", fullTitle);
    upsertMeta("property", "og:type", "website");
    if (image) upsertMeta("property", "og:image", image);
    if (url) {
      upsertMeta("property", "og:url", url);
      upsertCanonical(url);
    }
  }, [title, description, image, url, keywords]);
}
